import { render, staticRenderFns } from "./GoodsItem.vue?vue&type=template&id=3f1ed8fc&scoped=true&"
import script from "./GoodsItem.vue?vue&type=script&lang=js&"
export * from "./GoodsItem.vue?vue&type=script&lang=js&"
import style0 from "./GoodsItem.vue?vue&type=style&index=0&id=3f1ed8fc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.10.1_bd47uzbtgolpottv4tyra2y574/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f1ed8fc",
  null
  
)

export default component.exports